import React from 'react';

import { CheckboxProps } from './CheckboxTypes';

import StyledCheckbox from './StyledCheckbox';
import { FormattedMessage } from 'react-intl';

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { id, formattedMessageId, checked, disabled, onChange } = props;

  return (
    <StyledCheckbox>
      <input id={id} type="checkbox" checked={checked} onChange={onChange} disabled={disabled === true} />
      <label htmlFor={id}>{formattedMessageId && <FormattedMessage id={formattedMessageId} />}</label>
    </StyledCheckbox>
  );
};

export default Checkbox;
